import { Injectable } from '@angular/core';
import { GeneralHttpService } from 'src/app/shared/general-http.service';
import { CentroCostos } from './centro-costos.model';

@Injectable({
  providedIn: 'root'
})
export class CentroCostosService {
  listCentrosCostos: CentroCostos[];
  constructor(private generalHttp:GeneralHttpService) { }
  
  getCentros(){
    return this.generalHttp.getHttp('AdmCentroCostoes').then(r =>this.listCentrosCostos = r as CentroCostos[]);
  }

  updateCentros(){
    return this.generalHttp.putHttpNotValue('AdmCentroCostoes')
  }
}
